var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRisLogoBall(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.46 283.46",
    style: {
      enableBackground: "new 0 0 283.46 283.46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#80C342;}\n\t.st1{fill:#4B6A8F;}\n\t.st2{fill:#0091D0;}\n\t.st3{fill:#39B54A;}\n\t.st4{fill:#A6CE39;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.64,87.1c5.41,0.09,6.94-3.55,4.52-8.57c-2.42-5.02-8.3-9.14-13.54-9.28c-5.25-0.14-7.58,3.27-5.17,8.22 C202.84,82.41,209.23,87.02,214.64,87.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M244.99,148.39c-0.28,6.66,0.49,12.06,2.36,11.73s4.14-5.7,4.61-11.68c0.47-5.98-1.23-10.87-3.25-11.19 C246.7,136.92,245.27,141.73,244.99,148.39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M221.5,216.99c4.12-3.21,8.07-8.67,9.23-12.45c1.16-3.78-0.97-4.12-5.19-0.45c-4.23,3.67-8.8,9.52-9.86,12.84 C214.62,220.25,217.37,220.2,221.5,216.99"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M244.16,122.81c1.82,6.24,3.86,8.64,4.93,5.67c1.07-2.98,0.73-9.72-1.17-15.37c-1.9-5.66-4.56-8.47-5.56-6.07 C241.37,109.41,242.34,116.56,244.16,122.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M242.17,186.61c2.74-5.35,3.91-11.51,3.07-13.7c-0.84-2.19-3.67,1-6.71,6.99c-3.04,5.99-4.87,11.92-3.73,13.47 C235.94,194.92,239.43,191.96,242.17,186.61"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M131.98,144.46c-1.49,7.81,3.73,14.43,11.66,15.56c7.93,1.12,15.72-4.03,17.42-12.37 c1.7-8.34-4.08-16.29-12.1-16.95C140.94,130.04,133.47,136.65,131.98,144.46"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M191.74,93.71c4.92-2.9,4.54-9.19-0.56-13.76c-5.1-4.57-12.79-6.1-17.52-3.7c-4.73,2.4-4.85,8.18,0.05,13.25 C178.62,94.57,186.83,96.61,191.74,93.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M137.02,188.53c1.98,4.55,8.7,7.23,15.28,6.05c6.59-1.18,10.66-6.21,8.85-11.3 c-1.81-5.09-8.97-7.84-15.73-6.11C138.67,178.89,135.04,183.97,137.02,188.53"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.58,114.2c2.99-5.46,0.08-12.06-6.13-15.06c-6.22-3-13.37-1.66-16.33,3.23 c-2.96,4.9-0.63,11.95,5.56,15.51C159.86,121.44,167.59,119.66,170.58,114.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M158.31,215.27c4.12,2.92,11.52,3.36,16.85,0.66c5.33-2.71,6.58-7.85,2.43-11.1 c-4.14-3.24-12.12-3.07-17.43-0.04C154.86,207.82,154.2,212.35,158.31,215.27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M235.79,96.35c3.41,3.99,5.63,2.98,5.16-1.64c-0.47-4.62-3.56-10.94-7.08-14.63c-3.51-3.68-6-3.56-5.43,0.76 C229.02,85.15,232.38,92.36,235.79,96.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M194.35,223.15c3.88-0.64,9-3.67,11.7-7.16c2.7-3.5,1.99-6.13-1.95-5.41c-3.94,0.72-9.98,3.59-12.56,7.14 C188.96,221.27,190.47,223.79,194.35,223.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M149.21,236.43c5.97,1.96,15.64,1.5,22.07-1.36c6.43-2.86,6.89-7.5,0.37-9.83 c-6.52-2.33-17.18-1.17-23.07,2.06C142.69,230.54,143.24,234.47,149.21,236.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.19,67.07c4.49,2.97,5.72,1.41,3.17-2.84c-2.55-4.25-8.24-9.44-12.93-11.99 c-4.69-2.55-6.44-1.91-3.69,1.92C207.49,57.99,213.7,64.1,218.19,67.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.36,111.14c-2.71,8.18,2.69,17.94,13.1,20.87s21.85-3.1,24.43-12.3c2.58-9.2-4.5-17.32-14.77-19.22 C102.85,98.6,93.07,102.97,90.36,111.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M191.46,240.04c6.45-2.14,13.65-6.91,16.72-10.8c3.07-3.88,1.26-5.1-4.88-2.4 c-6.15,2.7-14.43,7.75-17.81,11.08C182.12,241.24,185.02,242.18,191.46,240.04"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M178.85,66.08c6.43-1.79,5.86-7.08-0.44-11.23c-6.3-4.15-15.37-6.07-21.11-4.71c-5.75,1.36-6.62,5.73-1,10.32 C161.92,65.04,172.42,67.87,178.85,66.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M86.51,172.2c1.76,8.3,10.79,14.01,20.97,13.32c10.17-0.69,17.98-8.32,16.64-17.92 c-1.34-9.59-11.67-16.36-22.26-14.39C91.26,155.19,84.75,163.9,86.51,172.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.49,84.24c5.06-5.12,1.44-12.1-6.85-15.6c-8.29-3.5-18.13-2.83-23.17,1.41 c-5.03,4.25-3.29,11.03,4.96,15.41C130.7,89.84,142.43,89.36,147.49,84.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M112.7,215.86c4.74,4.15,14.41,5.89,22.72,3.9c8.31-1.99,11.94-7.52,7.01-12.32 c-4.93-4.8-16.45-6.36-24.57-3.72C109.73,206.36,107.95,211.71,112.7,215.86"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M80.69,241.02c6.04,4.25,16.83,4.63,26.71,1.83c9.89-2.8,13.78-8.19,6.08-12.8c-7.7-4.61-22.91-6-31.13-2.85 C74.13,230.36,74.65,236.76,80.69,241.02"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M55.08,71.2c-6.31,6.37-3.78,14.25,7.42,18.08c11.21,3.83,27.37,0.5,33.5-7.4c6.13-7.9,0.05-15.95-10.99-18.25 C73.96,61.32,61.38,64.83,55.08,71.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M141.13,255.14c8.41,0.21,21.27-3.16,28.57-6.9c7.31-3.74,6.97-6.18-1.5-5.76 c-8.47,0.42-22.18,2.13-29.29,5.49C131.81,251.34,132.72,254.94,141.13,255.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M175.21,43.34c7.87-0.56,7.15-3.5,0.19-7.33c-6.96-3.83-16.9-6.77-22.94-6.68c-6.04,0.09-7.6,3.46-2.3,7.46 C155.46,40.79,167.34,43.9,175.21,43.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.84,142.38c-0.21,9.94,8.4,18.34,21.01,20.3c12.61,1.97,24.91-4.46,25.46-16.64 c0.56-12.17-11.04-23.99-24.07-23.83C37.22,122.36,28.05,132.44,27.84,142.38"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M132.37,53.63c7.85-3.62,4.99-9.91-2.91-13.91c-7.89-4-17.27-4.48-24.55-1.15c-7.29,3.33-9.89,9.01-2.58,13.3 C109.64,56.15,124.52,57.25,132.37,53.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M48.44,200.8c5.63,7.06,16.71,12.12,27.63,11.57c10.93-0.54,17.87-6.87,12.44-14.82 c-5.43-7.95-21.27-13.38-32.37-11.96C45.03,187.02,42.81,193.74,48.44,200.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M136.81,33.65c2.53-1.15,2.07-2.97-0.54-4.22c-2.61-1.25-6.12-1.52-8.35-0.42c-2.23,1.1-2.6,3.19-0.29,4.49 C129.94,34.79,134.28,34.8,136.81,33.65"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.61,174.55c1.31,3.1,5.34,5.9,9.37,6.31c4.03,0.41,6.59-1.89,5.32-5.21c-1.27-3.33-5.93-6.23-10-6.42 C26.24,169.06,24.31,171.45,25.61,174.55"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M28.23,100.15c-1.39,3.61,0.56,7.35,4.79,8.23c4.23,0.88,9.31-1.77,10.87-5.73c1.57-3.97-1.08-7.48-5.48-8 C34.01,94.13,29.62,96.54,28.23,100.15"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.08,226.21c2.38,2.48,6.07,3.77,8.88,2.99c2.81-0.78,3.59-3.28,1.08-5.71c-2.51-2.42-7.23-3.86-9.92-3.14 C55.43,221.08,55.7,223.73,58.08,226.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M68.95,48.6c-3.23,2.33-3.66,4.66-0.5,5.32c3.15,0.66,8.66-0.63,11.78-2.98c3.13-2.35,2.74-4.82-0.31-5.46 C76.87,44.84,72.18,46.27,68.95,48.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M124.47,243.24c2.48,0.75,6.82,0.43,9.82-0.65c3-1.07,3.37-2.57,0.69-3.38c-2.68-0.82-7.25-0.59-10.04,0.56 C122.14,240.91,121.99,242.49,124.47,243.24"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M196.64,46.63c2.69,1.03,3.33,0.52,1.53-1.12c-1.8-1.64-5.41-3.71-8.14-4.61c-2.73-0.9-3.52-0.41-1.68,1.1 C190.19,43.52,193.95,45.6,196.64,46.63"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M56.05,108.51c-1.28,3.62,1.03,7.5,5.45,8.5c4.41,1,9.33-1.48,10.64-5.35c1.31-3.86-1.47-7.46-5.93-8.21 C61.75,102.7,57.32,104.89,56.05,108.51"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRisLogoBall);
export default __webpack_public_path__ + "static/media/ris_logo_ball.eaed44c722bf04a9d7dedcd31397ba96.svg";
export { ForwardRef as ReactComponent };